<template>
  <div>
    <div class="vx-row mb-6">
      <div class="mb-8 vx-col md:w-1/2 w-full">
        <vs-input id="create-campaign-s3-adset-name-input" :label="$t('Ad Set Name')" v-model="value.name" :name="`step3.adsets.${adsetIndex}.name`" v-validate="'required|max:25'" :data-vv-as="$t('Ad Set Name')" :danger="$vErrors.has([errors, serverErrors], `step3.adsets.${adsetIndex}.name`)"  :placeholder="$t('Ad Set Name')" class="w-full" maxLength="25" />
        <span v-if="$vErrors.has([errors, serverErrors], `step3.adsets.${adsetIndex}.name`)" class="text-danger">
          {{ $vErrors.first([errors, serverErrors], `step3.adsets.${adsetIndex}.name`) }}
        </span>
      </div>

      <div class="vx-col md:w-1/2 w-full mb-4">
        <label class="input-label" for="language">{{ $t('Language') }}</label>

        <v-select
          @input="$gtag.event('Step3_Lang')"
          id="create-campaign-s3-language-list"
          v-model="value.language"
          :options="languages"
          :reduce="lang => lang.id"
          label="text"
          :clearable="false"

          :name="`step3.adsets.${adsetIndex}.language`"
          v-validate="'required'"
          :data-vv-as="$t('Language')"

          class="baisc-select mt-3"
          :dir="$vs.rtl ? 'rtl' : 'ltr'" />

        <span v-if="$vErrors.has([errors, serverErrors], `step3.adsets.${adsetIndex}.language`)" class="text-danger">
          {{ $vErrors.first([errors, serverErrors], `step3.adsets.${adsetIndex}.language`) }}
        </span>
      </div>
    </div>

    <!-- <vs-divider />

    <div class="vx-row mt-6 mb-10">
      <div class="vx-col w-full">
        <h4>
          <span class="inline-block align-middle mr-4">
            <feather-icon icon="UsersIcon" svgClasses="w-5 h-5" />
          </span>
          <span class="inline-block align-middle">
            {{ $t('Audience Targeting') }}
          </span>
        </h4>
        <p class="mt-3 text-gray-500 text-md">
          {{ $t("You can customize the characteristics of the audience you want to target.") }}
        </p>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full mb-4">
        <vs-radio v-model="value.new_audience" :vs-name="'new_audience-' + _uid" vs-value="true">
          {{ $t("Add new audience") }}
        </vs-radio>
      </div>

      <div class="vx-col md:w-1/2 w-full mb-4">
        <vs-radio v-model="value.new_audience" :vs-name="'new_audience-' + _uid" vs-value="false">
          {{ $t("Choose from saved audience") }}
        </vs-radio>
      </div>

      <div class="vx-col md:w-1/2 w-full mb-6 mt-6">
        <vs-input :label="$t('Audience Name')" :data-vv-as="$t('Audience Name')" :placeholder="$t('Audience Name')" class="w-full" name="new_audience_name" maxLength="25" v-model="value.new_audience_name" :danger="errors.has('new_audience_name')" v-validate="'required|max:25'" />
        <span v-if="errors.has('new_audience_name')" class="text-danger">
          {{ errors.first('new_audience_name') }}
        </span>
      </div>
    </div> -->
  </div>
</template>

<script>

export default {
  props: {
    value: {
      type: Object,
      required: true
    },
    adsetIndex: {
      type: Number,
      required: true
    },
    serverErrors: {
      required: true
    }
  },
  watch: {
    value: {
      handler (newVal) {
        this.$emit('input', newVal)
      },
      deep: true
    }
  },
  data () {
    return {
      languages: [
        {
          id: 1,
          text: 'English'
        },
        {
          id: 2,
          text: 'Arabic'
        }
      ]
    }
  }
}
</script>
